// Module
var code = "<script>let $panelServiceObject</script> <div ng-include=\"$panelServiceObject.getTemplate()\"></div> ";
// Exports
module.exports = code;